import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/denntenna.github.io/denntenna.github.io/src/components/default-mdx-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`A trip to Udaipur after 10 years`}</h1>
    <p>{`This included sitting in Indian Railways after ages. I fit in well except for the shoes.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1200px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/d7bb52b0d518dd98fc306337455b3497/e5166/udr-2023-01.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "133.33333333333331%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAbABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAIDBAX/xAAVAQEBAAAAAAAAAAAAAAAAAAABAP/aAAwDAQACEAMQAAABWRFLFBEWWKu8YBv/xAAaEAADAQEBAQAAAAAAAAAAAAAAAQIRAxAT/9oACAEBAAEFAq8wvaEqmlOn0jF303gYlIkf/8QAGBEAAgMAAAAAAAAAAAAAAAAAAAEQESH/2gAIAQMBAT8Bh6Uf/8QAFhEBAQEAAAAAAAAAAAAAAAAAABEx/9oACAECAQE/AUYr/8QAGxAAAQUBAQAAAAAAAAAAAAAAAAECEBEhQlH/2gAIAQEABj8CmkNs0tGopuN8OR9T/8QAHRABAAICAgMAAAAAAAAAAAAAAQARITFBYVGRof/aAAgBAQABPyHpdwF3d+Igc3DSv2LthhlS1KmuvRwS7mcgNzt9JVRWoBcFJ//aAAwDAQACAAMAAAAQx/bN/8QAGBEBAQEBAQAAAAAAAAAAAAAAAREAEDH/2gAIAQMBAT8QPLqZCWTj/8QAGBEBAQADAAAAAAAAAAAAAAAAABEBIUH/2gAIAQIBAT8Q7FsaKf/EABoQAQADAQEBAAAAAAAAAAAAAAEAESFBYTH/2gAIAQEAAT8QwAkuObBceLYoKE5GQK+riMfYLsZ8ertQ1aSyqtLYNLdoQp6zMuHBhXXjKTIFUtrqz//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Train",
            "title": "Train",
            "src": "/static/d7bb52b0d518dd98fc306337455b3497/e5166/udr-2023-01.jpg",
            "srcSet": ["/static/d7bb52b0d518dd98fc306337455b3497/f93b5/udr-2023-01.jpg 300w", "/static/d7bb52b0d518dd98fc306337455b3497/b4294/udr-2023-01.jpg 600w", "/static/d7bb52b0d518dd98fc306337455b3497/e5166/udr-2023-01.jpg 1200w"],
            "sizes": "(max-width: 1200px) 100vw, 1200px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1200px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/1e69d674453e522d0a2f64fa18f13372/e5166/udr-2023-02.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "133.33333333333331%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAbABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAIEAwH/xAAWAQEBAQAAAAAAAAAAAAAAAAABAgD/2gAMAwEAAhADEAAAAReTpWKVpdLccMbk3//EABwQAAICAwEBAAAAAAAAAAAAAAECAAMREiEEIv/aAAgBAQABBQJjwEZPI1bMCujjWH0fVlxSLcmLlBmAbFVdf//EABgRAAMBAQAAAAAAAAAAAAAAAAABESFR/9oACAEDAQE/ASixlXD/xAAXEQEAAwAAAAAAAAAAAAAAAAAAAREh/9oACAECAQE/AVJa/8QAGxAAAwEAAwEAAAAAAAAAAAAAAAEhEQIyQVH/2gAIAQEABj8CrwxM8FD4U1ccFpRQq8OqP//EAB0QAQACAgMBAQAAAAAAAAAAAAEAESExQVFhcbH/2gAIAQEAAT8hrwPUZStczJVqNQu4pWdJgyb+MfM9wdxbZZZiKKqfIkkaixQ1yIofhP/aAAwDAQACAAMAAAAQlw9+/8QAGhEBAAIDAQAAAAAAAAAAAAAAAQARECGh0f/aAAgBAwEBPxAdYOhIo3Tvs//EABgRAAMBAQAAAAAAAAAAAAAAAAABESFB/9oACAECAQE/EJpJpQidP//EAB4QAQACAwACAwAAAAAAAAAAAAEAESExUUGBYbHR/9oACAEBAAE/EArAcNIsRjbN/M2CKyhUZaHSvvkSXWhu+6jRb7n4QwJ4fZLhbVA9fYywEeFFgkBqB4dAA0VHltrmf//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Train",
            "title": "Train",
            "src": "/static/1e69d674453e522d0a2f64fa18f13372/e5166/udr-2023-02.jpg",
            "srcSet": ["/static/1e69d674453e522d0a2f64fa18f13372/f93b5/udr-2023-02.jpg 300w", "/static/1e69d674453e522d0a2f64fa18f13372/b4294/udr-2023-02.jpg 600w", "/static/1e69d674453e522d0a2f64fa18f13372/e5166/udr-2023-02.jpg 1200w"],
            "sizes": "(max-width: 1200px) 100vw, 1200px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p>{`The rooftop bars and cafes are all a rage now, i hear.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1024px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/cd0ebbbb18e24e6f242a2795c8c6ae11/72e01/udr-2023-19.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "47.333333333333336%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAJABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAIBAwX/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAABxCqVYQT/xAAYEAACAwAAAAAAAAAAAAAAAAABEQAgIv/aAAgBAQABBQJBZhVP/8QAFREBAQAAAAAAAAAAAAAAAAAAEBH/2gAIAQMBAT8Bp//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABcQAAMBAAAAAAAAAAAAAAAAAAEQISD/2gAIAQEABj8CpUx//8QAGhAAAQUBAAAAAAAAAAAAAAAAAQARICFBcf/aAAgBAQABPyEZhZFtxXULQ//aAAwDAQACAAMAAAAQbN//xAAWEQEBAQAAAAAAAAAAAAAAAAAAAXH/2gAIAQMBAT8Qwtf/xAAVEQEBAAAAAAAAAAAAAAAAAAAQEf/aAAgBAgEBPxCn/8QAHhABAAIBBAMAAAAAAAAAAAAAAQAhQRARMVFhofH/2gAIAQEAAT8QYEHWd/UbI9iW+cxOo8mYmdP/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Zini Cafe",
            "title": "Zini Cafe",
            "src": "/static/cd0ebbbb18e24e6f242a2795c8c6ae11/72e01/udr-2023-19.jpg",
            "srcSet": ["/static/cd0ebbbb18e24e6f242a2795c8c6ae11/f93b5/udr-2023-19.jpg 300w", "/static/cd0ebbbb18e24e6f242a2795c8c6ae11/b4294/udr-2023-19.jpg 600w", "/static/cd0ebbbb18e24e6f242a2795c8c6ae11/72e01/udr-2023-19.jpg 1024w"],
            "sizes": "(max-width: 1024px) 100vw, 1024px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1200px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/ea967c76ffeb6b5fa3c9abb368569da3/e5166/udr-2023-03.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "133.33333333333331%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAbABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAABAADBf/EABUBAQEAAAAAAAAAAAAAAAAAAAIB/9oADAMBAAIQAxAAAAEM8ZR5cajHDKLqwKj/xAAbEAACAwEBAQAAAAAAAAAAAAAAAQIDEiIRIf/aAAgBAQABBQLJmKbz7WlEcdWuMSx5G+1OJb9G+j//xAAXEQADAQAAAAAAAAAAAAAAAAABEBEi/9oACAEDAQE/AQIrlf/EABcRAAMBAAAAAAAAAAAAAAAAAAIQESH/2gAIAQIBAT8BIqpq/8QAHRAAAgEEAwAAAAAAAAAAAAAAAAEQESFBgRIxMv/aAAgBAQAGPwIvk6HyWCp5embEXhR//8QAHhAAAwACAQUAAAAAAAAAAAAAAAERITFREEFhgcH/2gAIAQEAAT8h0yYx22yiplfZ3pchioUb1SoizG3BBvikvIZsm+Rnq6f/2gAMAwEAAgADAAAAEHjaAP/EABkRAAMAAwAAAAAAAAAAAAAAAAARIUFhkf/aAAgBAwEBPxBZouuGIp//xAAZEQADAAMAAAAAAAAAAAAAAAAAARFBYZH/2gAIAQIBAT8QoicKt9M5Ef/EACEQAQADAAECBwAAAAAAAAAAAAEAESExEEFRcYGRobHB/9oACAEBAAE/EMWweLOOCFoHl+oQYqFOcxtoULBjToDptekAxL2H4gqaxL7Vv5BcS+Adhq68kQFWzGIu16f/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Train",
            "title": "Train",
            "src": "/static/ea967c76ffeb6b5fa3c9abb368569da3/e5166/udr-2023-03.jpg",
            "srcSet": ["/static/ea967c76ffeb6b5fa3c9abb368569da3/f93b5/udr-2023-03.jpg 300w", "/static/ea967c76ffeb6b5fa3c9abb368569da3/b4294/udr-2023-03.jpg 600w", "/static/ea967c76ffeb6b5fa3c9abb368569da3/e5166/udr-2023-03.jpg 1200w"],
            "sizes": "(max-width: 1200px) 100vw, 1200px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1024px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/c9d4f2fa3155e03d612845f1db5f894e/72e01/udr-2023-08.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAMEBQb/xAAXAQEBAQEAAAAAAAAAAAAAAAABAgAD/9oADAMBAAIQAxAAAAHRXj7JdyQ3m6nSbhP/xAAZEAEBAQEBAQAAAAAAAAAAAAABAgADESH/2gAIAQEAAQUCm8V9lqgrzc6bCWTc18et7//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8BH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8BH//EAB4QAAEDBAMAAAAAAAAAAAAAAAABAhEQEiGBIjFB/9oACAEBAAY/AjRNxydoV3hE0wp2f//EABwQAQADAAIDAAAAAAAAAAAAAAEAESExcUFR0f/aAAgBAQABPyG2mjiaemyoA9ECqomhhA1Ynkhaw6n2CshXqX9bP//aAAwDAQACAAMAAAAQA/8AQP/EABgRAAIDAAAAAAAAAAAAAAAAAAABEBEh/9oACAEDAQE/ENm2f//EABgRAQEAAwAAAAAAAAAAAAAAAAARASFB/9oACAECAQE/EJpHEw//xAAeEAEAAgICAwEAAAAAAAAAAAABABEhMUFRYXGx8P/aAAgBAQABPxAsILVWuIweBPAMsdgLrC/ZXo+xvoevUx76qNn5mnqurJNWHC+y7DWFVFEpChdz/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Train",
            "title": "Train",
            "src": "/static/c9d4f2fa3155e03d612845f1db5f894e/72e01/udr-2023-08.jpg",
            "srcSet": ["/static/c9d4f2fa3155e03d612845f1db5f894e/f93b5/udr-2023-08.jpg 300w", "/static/c9d4f2fa3155e03d612845f1db5f894e/b4294/udr-2023-08.jpg 600w", "/static/c9d4f2fa3155e03d612845f1db5f894e/72e01/udr-2023-08.jpg 1024w"],
            "sizes": "(max-width: 1024px) 100vw, 1024px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p>{`Although, nothing beats good old ganne-ka-ras with friends`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1200px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/cf24838362c0ff25be2441d90d6545ff/e5166/udr-2023-04.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "133.33333333333331%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAbABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAIEAwH/xAAWAQEBAQAAAAAAAAAAAAAAAAACAAH/2gAMAwEAAhADEAAAAWJLzoQGl1fs9jMN/8QAGxABAAIDAQEAAAAAAAAAAAAAAQARAgMSEDH/2gAIAQEAAQUC75juGY5WZNuinUjaTlsqbPp5/8QAGREAAwADAAAAAAAAAAAAAAAAAAERAhAh/9oACAEDAQE/AWp0hiq9f//EABgRAAIDAAAAAAAAAAAAAAAAAAABEBFR/9oACAECAQE/AVhbHH//xAAeEAACAQMFAAAAAAAAAAAAAAAAARECECExQVGC0f/aAAgBAQAGPwLBKTg9OppCN2ZJpqxxZX//xAAbEAEAAgMBAQAAAAAAAAAAAAABABEhMVFhQf/aAAgBAQABPyHLz9l9wzFtGj1U2YZsxKQ6NfIlX5pyNZY1SnIZSB1uWF3NKPC+zShP/9oADAMBAAIAAwAAABAb2wL/xAAZEQACAwEAAAAAAAAAAAAAAAAAARARIUH/2gAIAQMBAT8QpJOlXpnOP//EABcRAQEBAQAAAAAAAAAAAAAAAAERABD/2gAIAQIBAT8Qpw0oE5//xAAfEAEAAgICAgMAAAAAAAAAAAABABEhQTFxUaFhgdH/2gAIAQEAAT8QoNGjYvW+4WKWPL80cdwo5OCx7l9kJg2l/kGxloctiM9YaQBTATmCaMFiOsGLSPK/UB6BeRNzEWDODsiG5U+orjAOCf/Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Train",
            "title": "Train",
            "src": "/static/cf24838362c0ff25be2441d90d6545ff/e5166/udr-2023-04.jpg",
            "srcSet": ["/static/cf24838362c0ff25be2441d90d6545ff/f93b5/udr-2023-04.jpg 300w", "/static/cf24838362c0ff25be2441d90d6545ff/b4294/udr-2023-04.jpg 600w", "/static/cf24838362c0ff25be2441d90d6545ff/e5166/udr-2023-04.jpg 1200w"],
            "sizes": "(max-width: 1200px) 100vw, 1200px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p>{`I visited the usual suspects :`}</p>
    <p><strong parentName="p">{`Fateh Sagar`}</strong></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "768px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/0fee9b327d43e48ca1b83e650b9ff9d6/212bf/udr-2023-10.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "133.33333333333331%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAbABQDASIAAhEBAxEB/8QAGQAAAwADAAAAAAAAAAAAAAAAAAMFAQIE/8QAFQEBAQAAAAAAAAAAAAAAAAAAAQL/2gAMAwEAAhADEAAAAaqDRFAIqbVkzXaZB//EAB4QAAIBAwUAAAAAAAAAAAAAAAECABETMgMEEBQx/9oACAEBAAEFAmWEcdhTLik3FjsKbdqauUGKxfP/xAAWEQADAAAAAAAAAAAAAAAAAAAAEBH/2gAIAQMBAT8BI//EABYRAAMAAAAAAAAAAAAAAAAAAAAQEf/aAAgBAgEBPwEr/8QAHRAAAAUFAAAAAAAAAAAAAAAAAAEQETEgIUFRYf/aAAgBAQAGPwJcg+IbSD01w8Uf/8QAHRABAAICAgMAAAAAAAAAAAAAAQARITEQQVFxgf/aAAgBAQABPyGjU8jEiqkEpt+0RcC/JgfRqWBXJGLUy6IAL27hq+L/2gAMAwEAAgADAAAAECcfjP/EABURAQEAAAAAAAAAAAAAAAAAAAAR/9oACAEDAQE/EFIj/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAEREP/aAAgBAgEBPxBMnKf/xAAeEAEBAQACAQUAAAAAAAAAAAABEQAhUUExkaHB8P/aAAgBAQABPxAgqugLBnAYV5W5r0RS4l4JqSNPGcgfZw+cdnakHmZqMUd/nAgQXCemEAeV3iUkqfeT79//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Train",
            "title": "Train",
            "src": "/static/0fee9b327d43e48ca1b83e650b9ff9d6/212bf/udr-2023-10.jpg",
            "srcSet": ["/static/0fee9b327d43e48ca1b83e650b9ff9d6/f93b5/udr-2023-10.jpg 300w", "/static/0fee9b327d43e48ca1b83e650b9ff9d6/b4294/udr-2023-10.jpg 600w", "/static/0fee9b327d43e48ca1b83e650b9ff9d6/212bf/udr-2023-10.jpg 768w"],
            "sizes": "(max-width: 768px) 100vw, 768px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "768px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/d70ba069ae11ed1b849c98cee1c0f45a/212bf/udr-2023-11.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "133.33333333333331%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAbABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAQCAwUB/8QAFQEBAQAAAAAAAAAAAAAAAAAAAQD/2gAMAwEAAhADEAAAAdiEVkYOEK59as7peF//xAAdEAACAgEFAAAAAAAAAAAAAAABAgADEhARIzJB/9oACAEBAAEFAttWcwWknKNYBEu5cpf19SpCv//EABYRAQEBAAAAAAAAAAAAAAAAAAAREP/aAAgBAwEBPwFMj//EABYRAQEBAAAAAAAAAAAAAAAAABEAEP/aAAgBAgEBPwFnG//EABsQAAIDAAMAAAAAAAAAAAAAAAABEBEhAjFB/9oACAEBAAY/ApziNY6NQr9ZqSuFHR//xAAeEAACAgICAwAAAAAAAAAAAAAAAREhQXEQMVGBsf/aAAgBAQABPyFsOSCH9GX0OyFNWJj3FAXoCteeN9xj6F1ub2z/2gAMAwEAAgADAAAAEKPyc//EABgRAAIDAAAAAAAAAAAAAAAAAAARARAx/9oACAEDAQE/EFSMGP/EABcRAAMBAAAAAAAAAAAAAAAAAAABEBH/2gAIAQIBAT8QVcn/xAAgEAEAAwABAwUAAAAAAAAAAAABABEhMUFRYXGRodHh/9oACAEBAAE/ECcMNUXHmXgMF9xyHJ6M1V+ZWqjobB5tB7VDyy1KCSNbZsr2faJsN/li366+ZYvOV+yf/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Train",
            "title": "Train",
            "src": "/static/d70ba069ae11ed1b849c98cee1c0f45a/212bf/udr-2023-11.jpg",
            "srcSet": ["/static/d70ba069ae11ed1b849c98cee1c0f45a/f93b5/udr-2023-11.jpg 300w", "/static/d70ba069ae11ed1b849c98cee1c0f45a/b4294/udr-2023-11.jpg 600w", "/static/d70ba069ae11ed1b849c98cee1c0f45a/212bf/udr-2023-11.jpg 768w"],
            "sizes": "(max-width: 768px) 100vw, 768px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1024px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/0780527f837874521f91a65d76686ad4/72e01/udr-2023-12.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAABAABBf/EABUBAQEAAAAAAAAAAAAAAAAAAAEA/9oADAMBAAIQAxAAAAFwdIXagSf/xAAbEAABBQEBAAAAAAAAAAAAAAABAAIDBBMhMf/aAAgBAQABBQKxPm2KyCVIeeP1X//EABURAQEAAAAAAAAAAAAAAAAAAAAR/9oACAEDAQE/AUf/xAAVEQEBAAAAAAAAAAAAAAAAAAAAEf/aAAgBAgEBPwFX/8QAHBAAAgICAwAAAAAAAAAAAAAAABEBIRASMUGR/9oACAEBAAY/Aqhya35hNnCOz//EABwQAQACAwADAAAAAAAAAAAAAAEAIRExUUFxgf/aAAgBAQABPyEDyJw1DKbdtHL5gOJLiwbFX2MPb9n/2gAMAwEAAgADAAAAELz/AP/EABURAQEAAAAAAAAAAAAAAAAAAAEQ/9oACAEDAQE/EEj/xAAVEQEBAAAAAAAAAAAAAAAAAAABEP/aAAgBAgEBPxAj/8QAGxABAAIDAQEAAAAAAAAAAAAAAQARITFRYYH/2gAIAQEAAT8Q0MzeA9vV8IzFnsbfLiS9XyJlRuxWnse2AGmuBNwUw+yJ/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Train",
            "title": "Train",
            "src": "/static/0780527f837874521f91a65d76686ad4/72e01/udr-2023-12.jpg",
            "srcSet": ["/static/0780527f837874521f91a65d76686ad4/f93b5/udr-2023-12.jpg 300w", "/static/0780527f837874521f91a65d76686ad4/b4294/udr-2023-12.jpg 600w", "/static/0780527f837874521f91a65d76686ad4/72e01/udr-2023-12.jpg 1024w"],
            "sizes": "(max-width: 1024px) 100vw, 1024px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1024px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/4a2f23e5048c613dcca9cf2cc07be265/72e01/udr-2023-13.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAMFBP/EABYBAQEBAAAAAAAAAAAAAAAAAAEAAv/aAAwDAQACEAMQAAAB55buPlg3ycEyaAv/xAAaEAACAwEBAAAAAAAAAAAAAAABAgADERIy/9oACAEBAAEFAmwTJrSwBprravkk9c7ASo//xAAVEQEBAAAAAAAAAAAAAAAAAAAgMf/aAAgBAwEBPwGj/8QAFhEBAQEAAAAAAAAAAAAAAAAAEQAQ/9oACAECAQE/ASN//8QAHhAAAgEDBQAAAAAAAAAAAAAAAAERAhAhEjEyUaH/2gAIAQEABj8C3m3Hw0dopl5ETLMyQmf/xAAcEAEAAgMAAwAAAAAAAAAAAAABABEhMVFhcZH/2gAIAQEAAT8hIeDkMNesTivqbEZJdCbWx5Bu4gZwVuOxKXABP//aAAwDAQACAAMAAAAQNMAC/8QAFREBAQAAAAAAAAAAAAAAAAAAIGH/2gAIAQMBAT8Qof/EABcRAAMBAAAAAAAAAAAAAAAAAAABEBH/2gAIAQIBAT8QYxf/xAAcEAEBAQEBAAMBAAAAAAAAAAABEQAxQSFRgdH/2gAIAQEAAT8QJDVCnjN0olB3kGLD22AWVwT0kfx0YR8NZPV++YFEBaOhMYIuM/mJiQIVxTr0Hf/Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Train",
            "title": "Train",
            "src": "/static/4a2f23e5048c613dcca9cf2cc07be265/72e01/udr-2023-13.jpg",
            "srcSet": ["/static/4a2f23e5048c613dcca9cf2cc07be265/f93b5/udr-2023-13.jpg 300w", "/static/4a2f23e5048c613dcca9cf2cc07be265/b4294/udr-2023-13.jpg 600w", "/static/4a2f23e5048c613dcca9cf2cc07be265/72e01/udr-2023-13.jpg 1024w"],
            "sizes": "(max-width: 1024px) 100vw, 1024px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1024px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/3c2b560cd8934be1ab7b231c8fc979dd/72e01/udr-2023-14.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMEAf/EABUBAQEAAAAAAAAAAAAAAAAAAAEA/9oADAMBAAIQAxAAAAGR2MGMuI//xAAaEAACAwEBAAAAAAAAAAAAAAABAgAREgMh/9oACAEBAAEFAsERUuNYb3R3a9GA/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAGRABAQEAAwAAAAAAAAAAAAAAAAERISJB/9oACAEBAAY/AnsXW2OrmP/EABoQAAMBAQEBAAAAAAAAAAAAAAABESExUWH/2gAIAQEAAT8hbzwa2cefSIZtkxb30dKiSQwC2f/aAAwDAQACAAMAAAAQM8//xAAXEQADAQAAAAAAAAAAAAAAAAAAARFB/9oACAEDAQE/EHMIf//EABYRAQEBAAAAAAAAAAAAAAAAAAEAEf/aAAgBAgEBPxALC//EABwQAQACAgMBAAAAAAAAAAAAAAEAESExQXGB0f/aAAgBAQABPxAqopqlLghdXBWBvq4BM3LTuXoA2vYzrr7DpkeDglCYtrif/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Train",
            "title": "Train",
            "src": "/static/3c2b560cd8934be1ab7b231c8fc979dd/72e01/udr-2023-14.jpg",
            "srcSet": ["/static/3c2b560cd8934be1ab7b231c8fc979dd/f93b5/udr-2023-14.jpg 300w", "/static/3c2b560cd8934be1ab7b231c8fc979dd/b4294/udr-2023-14.jpg 600w", "/static/3c2b560cd8934be1ab7b231c8fc979dd/72e01/udr-2023-14.jpg 1024w"],
            "sizes": "(max-width: 1024px) 100vw, 1024px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p><strong parentName="p">{`Sajjan Garh`}</strong></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1200px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/70ef8f35b7e72d9b4711238baa385d43/e5166/udr-2023-05.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "133.33333333333331%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAbABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAMEAgX/xAAWAQEBAQAAAAAAAAAAAAAAAAAAAQL/2gAMAwEAAhADEAAAAeovSEnLjGo8OXThJH//xAAcEAACAwADAQAAAAAAAAAAAAABAgAREgMTMiH/2gAIAQEAAQUC+U5pe25oTRrjXK2XPECs0RE8D3P/xAAWEQEBAQAAAAAAAAAAAAAAAAARABD/2gAIAQMBAT8BI3//xAAXEQADAQAAAAAAAAAAAAAAAAAAEBES/9oACAECAQE/Aaaf/8QAGhAAAgMBAQAAAAAAAAAAAAAAAAEQETECQf/aAAgBAQAGPwIbSNah17FLB33Zohx//8QAHBAAAgICAwAAAAAAAAAAAAAAAAERITFBUWFx/9oACAEBAAE/Ie15HTrCxySt4oQ4NlCjeWcCYMzY3NO7LZe9ciQhMLHcUSt2Sf/aAAwDAQACAAMAAAAQCO5//8QAFxEBAQEBAAAAAAAAAAAAAAAAABEhQf/aAAgBAwEBPxAlzVf/xAAXEQEBAQEAAAAAAAAAAAAAAAAAARFh/9oACAECAQE/EIacjH//xAAeEAEBAAIBBQEAAAAAAAAAAAABEQAhMUFRYXGB4f/aAAgBAQABPxCQbSgdzxlfGwecKKZ1CA/TAsFejF9yNPCkhgeBtaHfFah9cH3uAdT9ZIIc6wlBGl87xOqGz3MVec//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Train",
            "title": "Train",
            "src": "/static/70ef8f35b7e72d9b4711238baa385d43/e5166/udr-2023-05.jpg",
            "srcSet": ["/static/70ef8f35b7e72d9b4711238baa385d43/f93b5/udr-2023-05.jpg 300w", "/static/70ef8f35b7e72d9b4711238baa385d43/b4294/udr-2023-05.jpg 600w", "/static/70ef8f35b7e72d9b4711238baa385d43/e5166/udr-2023-05.jpg 1200w"],
            "sizes": "(max-width: 1200px) 100vw, 1200px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1200px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/fa6ce084adb06539b3d7e174a3c35fd9/e5166/udr-2023-06.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "133.33333333333331%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAbABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAMBAgQF/8QAFgEBAQEAAAAAAAAAAAAAAAAAAAEC/9oADAMBAAIQAxAAAAHoxVCQOM6zroG4xkv/xAAcEAABBAMBAAAAAAAAAAAAAAABAAIDERIiMSH/2gAIAQEAAQUCrUmk6UAseHRybjDFOPrMkJBUXOFf/8QAFhEAAwAAAAAAAAAAAAAAAAAAABAR/9oACAEDAQE/ASP/xAAXEQADAQAAAAAAAAAAAAAAAAAAEBES/9oACAECAQE/AaaUP//EAB0QAAICAgMBAAAAAAAAAAAAAAABERIQIUFRcZH/2gAIAQEABj8Cj5jssnpkczohFUOz8Njz/8QAHBABAAICAwEAAAAAAAAAAAAAAQARIVExQWFx/9oACAEBAAE/IcKFQjsYlNz8QZQG8yhE2JQivvrPW9uogUU0JwlXZMm7hkCE/9oADAMBAAIAAwAAABBfxcD/xAAWEQEBAQAAAAAAAAAAAAAAAAARABD/2gAIAQMBAT8QI43/xAAXEQEBAQEAAAAAAAAAAAAAAAAAETEh/9oACAECAQE/EMKZxD//xAAdEAEBAAIDAAMAAAAAAAAAAAABEQAhMUFRYYGh/9oACAEBAAE/EAK8KkSX3JG4N84kjtp0fGItgKjlc0BNnXP7iBIlV32LmsZWAeRI6EPHJAd16GbJtMXG6KcT6zcrn//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Train",
            "title": "Train",
            "src": "/static/fa6ce084adb06539b3d7e174a3c35fd9/e5166/udr-2023-06.jpg",
            "srcSet": ["/static/fa6ce084adb06539b3d7e174a3c35fd9/f93b5/udr-2023-06.jpg 300w", "/static/fa6ce084adb06539b3d7e174a3c35fd9/b4294/udr-2023-06.jpg 600w", "/static/fa6ce084adb06539b3d7e174a3c35fd9/e5166/udr-2023-06.jpg 1200w"],
            "sizes": "(max-width: 1200px) 100vw, 1200px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1200px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/5cba4ac808bb328633d622c66751d5bd/b17f8/udr-2023-07.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAABAABAv/EABUBAQEAAAAAAAAAAAAAAAAAAAEC/9oADAMBAAIQAxAAAAFvZtRkGl//xAAbEAABBAMAAAAAAAAAAAAAAAACAAEDERASIv/aAAgBAQABBQIpuQlsdk1Mqx//xAAVEQEBAAAAAAAAAAAAAAAAAAAAEf/aAAgBAwEBPwFH/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAESIf/aAAgBAgEBPwF4ij//xAAZEAACAwEAAAAAAAAAAAAAAAABEBEhMQD/2gAIAQEABj8CoXwnVB1//8QAGhABAAIDAQAAAAAAAAAAAAAAAQARITFBcf/aAAgBAQABPyFRtwlkxWyeoNIrbUpg4SnjP//aAAwDAQACAAMAAAAQFN//xAAXEQEAAwAAAAAAAAAAAAAAAAABEBEh/9oACAEDAQE/ECnI/wD/xAAWEQEBAQAAAAAAAAAAAAAAAAARARD/2gAIAQIBAT8QSXP/xAAZEAEBAQEBAQAAAAAAAAAAAAABEQAhMaH/2gAIAQEAAT8QPd5BfuhoNQ8NCXAAB+3wbkNhAGbq0hzrv//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Train",
            "title": "Train",
            "src": "/static/5cba4ac808bb328633d622c66751d5bd/e5166/udr-2023-07.jpg",
            "srcSet": ["/static/5cba4ac808bb328633d622c66751d5bd/f93b5/udr-2023-07.jpg 300w", "/static/5cba4ac808bb328633d622c66751d5bd/b4294/udr-2023-07.jpg 600w", "/static/5cba4ac808bb328633d622c66751d5bd/e5166/udr-2023-07.jpg 1200w", "/static/5cba4ac808bb328633d622c66751d5bd/b17f8/udr-2023-07.jpg 1600w"],
            "sizes": "(max-width: 1200px) 100vw, 1200px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1024px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/06c9f285143fa733982a2aff3ca8dc17/72e01/udr-2023-15.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAQCBf/EABcBAAMBAAAAAAAAAAAAAAAAAAABAgP/2gAMAwEAAhADEAAAAbMc6cvtoCizBnpgC//EABwQAAIBBQEAAAAAAAAAAAAAAAARAgEDEhMgIf/aAAgBAQABBQLJG2Iy8R9q1x//xAAZEQABBQAAAAAAAAAAAAAAAAABAAIQEUH/2gAIAQMBAT8BDRqqf//EABYRAQEBAAAAAAAAAAAAAAAAABEAEP/aAAgBAgEBPwFnf//EABoQAAEFAQAAAAAAAAAAAAAAAAABECAxQUL/2gAIAQEABj8CLbTUOof/xAAbEAEBAQACAwAAAAAAAAAAAAABABEhMXGBkf/aAAgBAQABPyFI1cnSmzuSZh7webDxPGHwTYZN/9oADAMBAAIAAwAAABAz8AP/xAAXEQADAQAAAAAAAAAAAAAAAAAAESEQ/9oACAEDAQE/EEao+//EABcRAAMBAAAAAAAAAAAAAAAAAAABERD/2gAIAQIBAT8QSyk7/8QAGxABAAIDAQEAAAAAAAAAAAAAAQARITFREEH/2gAIAQEAAT8QqzHWYCgwQSw/YQ6W6yJscDnqBkoBsSErUWtXj//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Train",
            "title": "Train",
            "src": "/static/06c9f285143fa733982a2aff3ca8dc17/72e01/udr-2023-15.jpg",
            "srcSet": ["/static/06c9f285143fa733982a2aff3ca8dc17/f93b5/udr-2023-15.jpg 300w", "/static/06c9f285143fa733982a2aff3ca8dc17/b4294/udr-2023-15.jpg 600w", "/static/06c9f285143fa733982a2aff3ca8dc17/72e01/udr-2023-15.jpg 1024w"],
            "sizes": "(max-width: 1024px) 100vw, 1024px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p><strong parentName="p">{` Pichola Lake/Gangaur Ghat`}</strong></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "768px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/6d3fd7257cfc0298bafabc81382c4533/212bf/udr-2023-09.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "133.33333333333331%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAbABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAECBAUD/8QAFwEBAQEBAAAAAAAAAAAAAAAAAgMAAf/aAAwDAQACEAMQAAAB1JUnN3igIZqjyz0RnIf/xAAdEAACAgMAAwAAAAAAAAAAAAABAgADERIiEyMz/9oACAEBAAEFAkblG9Y6CuCEtyvlIlpNcqsbdkba85lf0zP/xAAaEQACAgMAAAAAAAAAAAAAAAAAAQIRAxIh/9oACAEDAQE/AWjhJvax4ot2f//EABcRAAMBAAAAAAAAAAAAAAAAAAABIRD/2gAIAQIBAT8BWJQp/8QAIBAAAgEBCQAAAAAAAAAAAAAAAAERAhASITEyQVFhkf/aAAgBAQAGPwJ9EkyNLcqp4IvLwzEpNJiKz//EAB0QAQACAwADAQAAAAAAAAAAAAEAESExURBBgfH/2gAIAQEAAT8httsVm5aN+xUBFywTSUVv2SKaYOwEBReM2OFqpeZfI1XL88FXZ//aAAwDAQACAAMAAAAQOBwz/8QAGxEBAAICAwAAAAAAAAAAAAAAAQAxESFRkfD/2gAIAQMBAT8QYcNxcrO4pK44S79xP//EABgRAQEBAQEAAAAAAAAAAAAAAAEAESEx/9oACAECAQE/EFvkPIuYQYX/xAAhEAEAAwAABgMBAAAAAAAAAAABABEhMUFRYXGRocHR8P/aAAgBAQABPxBDWdYddICq0Fw3jKXIXWZ8Tc9zKa/YQhtTFYqcPcU1KrT6hCE67B/MtNhO3Hv52B673EspYDa7Ibv5NnmJeL3P/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Train",
            "title": "Train",
            "src": "/static/6d3fd7257cfc0298bafabc81382c4533/212bf/udr-2023-09.jpg",
            "srcSet": ["/static/6d3fd7257cfc0298bafabc81382c4533/f93b5/udr-2023-09.jpg 300w", "/static/6d3fd7257cfc0298bafabc81382c4533/b4294/udr-2023-09.jpg 600w", "/static/6d3fd7257cfc0298bafabc81382c4533/212bf/udr-2023-09.jpg 768w"],
            "sizes": "(max-width: 768px) 100vw, 768px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1024px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/2a13cc60bc6d20b000c09a5d98aa6761/72e01/udr-2023-18.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAAMBAAAAAAAAAAAAAAAAAAIDBAX/xAAWAQEBAQAAAAAAAAAAAAAAAAADAAT/2gAMAwEAAhADEAAAAbIUZjTpiz3ifIIf/8QAHRAAAQQCAwAAAAAAAAAAAAAAAgABAzIEEhEjM//aAAgBAQABBQITEI4sjYzvx0Reh31Z0wCyO/8A/8QAFhEAAwAAAAAAAAAAAAAAAAAAAAEQ/9oACAEDAQE/AR3/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAcEAACAgIDAAAAAAAAAAAAAAAAAQIREiExQXH/2gAIAQEABj8ClNLsxa5GSvW0L0ZT2hOhn//EAB4QAQACAgEFAAAAAAAAAAAAAAEAETFBIVFhcZGh/9oACAEBAAE/IVQV3ZjgboSakwOCqX8ek+iV6xHFQ4iJF7Z//9oADAMBAAIAAwAAABBw8EP/xAAZEQACAwEAAAAAAAAAAAAAAAAAARARITH/2gAIAQMBAT8QrLG1w+n/xAAVEQEBAAAAAAAAAAAAAAAAAAAgIf/aAAgBAgEBPxCD/8QAHRABAAICAwEBAAAAAAAAAAAAAQARITFBUWGBof/aAAgBAQABPxB5Rhp2JRxiB/CRGvIHCxfcwOsI3cIrFoT6PyK4lEIFQDnompHSEcD3P//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Train",
            "title": "Train",
            "src": "/static/2a13cc60bc6d20b000c09a5d98aa6761/72e01/udr-2023-18.jpg",
            "srcSet": ["/static/2a13cc60bc6d20b000c09a5d98aa6761/f93b5/udr-2023-18.jpg 300w", "/static/2a13cc60bc6d20b000c09a5d98aa6761/b4294/udr-2023-18.jpg 600w", "/static/2a13cc60bc6d20b000c09a5d98aa6761/72e01/udr-2023-18.jpg 1024w"],
            "sizes": "(max-width: 1024px) 100vw, 1024px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p>{`The thing that was closest to my heart though was visiting the colony and house I grew up in`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1024px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/1c5c3e8fc36e260663b32f7d16f677db/72e01/udr-2023-16.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAABAACBf/EABQBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAR9YOQZFl//EABwQAAEEAwEAAAAAAAAAAAAAAAABAgMTERIhFP/aAAgBAQABBQLqEk2sdz3FiY9KPOn/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAbEAABBAMAAAAAAAAAAAAAAAAhAAEQEgIRMf/aAAgBAQAGPwIodi1duji0f//EABsQAQEAAwADAAAAAAAAAAAAAAERACFBUXGB/9oACAEBAAE/Id098UC7PGG8CcwmUJvcMVBTy3LyB9z/2gAMAwEAAgADAAAAEHTP/8QAFhEBAQEAAAAAAAAAAAAAAAAAAAER/9oACAEDAQE/EK1//8QAFhEBAQEAAAAAAAAAAAAAAAAAAQAR/9oACAECAQE/EASy/8QAHhABAAICAQUAAAAAAAAAAAAAAQARITFxQVGBkdH/2gAIAQEAAT8QANV2cCDFrm2Oz6hFNNKN+Yk8dlQxxmKdJrIq4s2U9B/J/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Train",
            "title": "Train",
            "src": "/static/1c5c3e8fc36e260663b32f7d16f677db/72e01/udr-2023-16.jpg",
            "srcSet": ["/static/1c5c3e8fc36e260663b32f7d16f677db/f93b5/udr-2023-16.jpg 300w", "/static/1c5c3e8fc36e260663b32f7d16f677db/b4294/udr-2023-16.jpg 600w", "/static/1c5c3e8fc36e260663b32f7d16f677db/72e01/udr-2023-16.jpg 1024w"],
            "sizes": "(max-width: 1024px) 100vw, 1024px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1024px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/df5b6ee9dcc54a10f9a0dea3331dce00/72e01/udr-2023-17.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAQCAwX/xAAWAQEBAQAAAAAAAAAAAAAAAAABAAL/2gAMAwEAAhADEAAAAWq18/K4SG//xAAbEAEBAAIDAQAAAAAAAAAAAAABAgMRABITI//aAAgBAQABBQJXTFdUxPMvzj1pZnc//8QAFhEBAQEAAAAAAAAAAAAAAAAAAAER/9oACAEDAQE/Aax//8QAFREBAQAAAAAAAAAAAAAAAAAAABH/2gAIAQIBAT8BV//EABoQAAICAwAAAAAAAAAAAAAAAAABETESMnH/2gAIAQEABj8CpLrNicUXJYj/xAAZEAEBAQEBAQAAAAAAAAAAAAABIQARMcH/2gAIAQEAAT8hedAqeid9+bh0pcbnRlzUwFgE3//aAAwDAQACAAMAAAAQ/wAv/8QAGBEAAgMAAAAAAAAAAAAAAAAAAAERIUH/2gAIAQMBAT8QRKien//EABYRAQEBAAAAAAAAAAAAAAAAAAEAIf/aAAgBAgEBPxAV2L//xAAbEAEAAgMBAQAAAAAAAAAAAAABESEAMUFRof/aAAgBAQABPxA+lpJFC+R3ITAua+p9ZIKCRGnpjQBOhq5rzGSyLrhlTAzW3P/Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Train",
            "title": "Train",
            "src": "/static/df5b6ee9dcc54a10f9a0dea3331dce00/72e01/udr-2023-17.jpg",
            "srcSet": ["/static/df5b6ee9dcc54a10f9a0dea3331dce00/f93b5/udr-2023-17.jpg 300w", "/static/df5b6ee9dcc54a10f9a0dea3331dce00/b4294/udr-2023-17.jpg 600w", "/static/df5b6ee9dcc54a10f9a0dea3331dce00/72e01/udr-2023-17.jpg 1024w"],
            "sizes": "(max-width: 1024px) 100vw, 1024px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p>{`I brought back parts of Udaipur with me`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "518px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/4b008860038f93ce9ec8c8bf5e2dfcf2/bc760/udr-2023-20.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "197.66666666666666%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAoABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAMEBQL/xAAXAQEBAQEAAAAAAAAAAAAAAAAAAQID/9oADAMBAAIQAxAAAAGOS+LPTWGExnzUJ3NAQRysB4B//8QAHxAAAQMDBQAAAAAAAAAAAAAAAgABMQMiMgQREhMh/9oACAEBAAEFAq537qm/INTA5KqTEwz2MjxFrkUNL+L/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AV//xAAWEQADAAAAAAAAAAAAAAAAAAABECD/2gAIAQIBAT8BQj//xAAZEAEBAAMBAAAAAAAAAAAAAAABEAARQSD/2gAIAQEABj8C0cguGEJ3yT//xAAdEAADAAICAwAAAAAAAAAAAAAAAREhMWGhEEGR/9oACAEBAAE/IXZmkE1xR6BGIrRVvZ2PEWT37OlnEF+TA5MDV0YOj0ZIz//aAAwDAQACAAMAAAAQa/8ADQ/v/8QAFxEBAQEBAAAAAAAAAAAAAAAAAREAEP/aAAgBAwEBPxAKcV105//EABgRAAMBAQAAAAAAAAAAAAAAAAAQEQEx/9oACAECAQE/EMXBCr//xAAeEAEBAQADAAIDAAAAAAAAAAABEQAhMUFRgaGx0f/aAAgBAQABPxCokKDy+6WKl4j7kpdLTue4YSlY5eN92f3vXRYSuGkPuB+fxH9wVDlDvL4AzQdAY0aX40dARgwOYO//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Mr Fancy Pants",
            "title": "Mr Fancy Pants",
            "src": "/static/4b008860038f93ce9ec8c8bf5e2dfcf2/bc760/udr-2023-20.jpg",
            "srcSet": ["/static/4b008860038f93ce9ec8c8bf5e2dfcf2/f93b5/udr-2023-20.jpg 300w", "/static/4b008860038f93ce9ec8c8bf5e2dfcf2/bc760/udr-2023-20.jpg 518w"],
            "sizes": "(max-width: 518px) 100vw, 518px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "768px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/df0c596a3656fabffdf87063bb5a92d7/212bf/udr-2023-21.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "133.33333333333331%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAbABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAQFAwL/xAAXAQADAQAAAAAAAAAAAAAAAAAAAgMB/9oADAMBAAIQAxAAAAF+duiPQMSezmFO2vQGxY//xAAcEAACAgMBAQAAAAAAAAAAAAABAgADERIhIkH/2gAIAQEAAQUCe1UC3Nln7ZV7IIIPNzsvXwJ8UzUT/8QAFhEBAQEAAAAAAAAAAAAAAAAAEQAB/9oACAEDAQE/AcCIYv/EABYRAAMAAAAAAAAAAAAAAAAAAAAQEf/aAAgBAgEBPwEr/8QAHhAAAgAGAwAAAAAAAAAAAAAAAAECEBESITFRUoH/2gAIAQEABj8Cfbgy6mC67YknVyqIxGvZ6P/EABwQAQACAgMBAAAAAAAAAAAAAAEAESExQWFxkf/aAAgBAQABPyEQsaWRmqHkUZSobpaJALpu5yKuFdtvcq+948lXB6QhikcjFcp+T//aAAwDAQACAAMAAAAQd8PD/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAEhEf/aAAgBAwEBPxBaGRpTKP/EABcRAQEBAQAAAAAAAAAAAAAAAAERABD/2gAIAQIBAT8QoMcu6c//xAAdEAEBAQEAAwADAAAAAAAAAAABEQAhMVFhQXGh/9oACAEBAAE/EEyZ2Ov10OleiA/mr7LBb3BhdiPLz8Z7WscQvzTF/qdcAo9X2buIbU5E8ayA9BUxBp5FwcgCPrPCKlVG/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "The Hat",
            "title": "The Hat",
            "src": "/static/df0c596a3656fabffdf87063bb5a92d7/212bf/udr-2023-21.jpg",
            "srcSet": ["/static/df0c596a3656fabffdf87063bb5a92d7/f93b5/udr-2023-21.jpg 300w", "/static/df0c596a3656fabffdf87063bb5a92d7/b4294/udr-2023-21.jpg 600w", "/static/df0c596a3656fabffdf87063bb5a92d7/212bf/udr-2023-21.jpg 768w"],
            "sizes": "(max-width: 768px) 100vw, 768px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1024px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/ddabfe4ef0af2349c1fef98b1be572d7/72e01/udr-2023-22.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "77.33333333333333%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAIDBP/EABYBAQEBAAAAAAAAAAAAAAAAAAIAAf/aAAwDAQACEAMQAAABuk1C1Gc2/8QAGRABAQEAAwAAAAAAAAAAAAAAAQIAAxES/9oACAEBAAEFAm/MnNmkazO7N//EABcRAQADAAAAAAAAAAAAAAAAAAABEVH/2gAIAQMBAT8BXOP/xAAWEQEBAQAAAAAAAAAAAAAAAAAAARH/2gAIAQIBAT8BZH//xAAaEAACAgMAAAAAAAAAAAAAAAAAIQExAjKh/9oACAEBAAY/AliNF8FNok2P/8QAGxAAAwEBAAMAAAAAAAAAAAAAAAERITFBobH/2gAIAQEAAT8h7s3ZCW4PW2Oy2Eqk21OcQ/FV+j8/of/aAAwDAQACAAMAAAAQ/D//xAAWEQADAAAAAAAAAAAAAAAAAAABEDH/2gAIAQMBAT8QhQ//xAAWEQEBAQAAAAAAAAAAAAAAAAABAEH/2gAIAQIBAT8QY1b/xAAdEAEAAgIDAQEAAAAAAAAAAAABABEhMUFRYXGB/9oACAEBAAE/EAIEoFWjtlhdUCXRr8ikGd4183L/AJYQJS75xxEliAVLA3kD53iBRAU1bHk//9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Fridge Magnet",
            "title": "Fridge Magnet",
            "src": "/static/ddabfe4ef0af2349c1fef98b1be572d7/72e01/udr-2023-22.jpg",
            "srcSet": ["/static/ddabfe4ef0af2349c1fef98b1be572d7/f93b5/udr-2023-22.jpg 300w", "/static/ddabfe4ef0af2349c1fef98b1be572d7/b4294/udr-2023-22.jpg 600w", "/static/ddabfe4ef0af2349c1fef98b1be572d7/72e01/udr-2023-22.jpg 1024w"],
            "sizes": "(max-width: 1024px) 100vw, 1024px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "671px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/cec721bd6a095e790957b33ad9d42461/9aaa0/udr-2023-23.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "152.66666666666669%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAfABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAIEAwX/xAAWAQEBAQAAAAAAAAAAAAAAAAABAgD/2gAMAwEAAhADEAAAAVp59E0E4yrY7OoAN//EABwQAAICAgMAAAAAAAAAAAAAAAECAAMREgQQMf/aAAgBAQABBQKkCEhYbMTjnWyw7TWM7MqjFnQ9n//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8BH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8BH//EAB0QAAEEAgMAAAAAAAAAAAAAAAABEBEhElEicYH/2gAIAQEABj8CyWF0dm/TlVG2uBXlv//EABsQAQADAAMBAAAAAAAAAAAAAAEAESEQQWFx/9oACAEBAAE/IaO5dH2VHUC6o9RuYCdIaATXHIx1kIHVca0Qp8oOT//aAAwDAQACAAMAAAAQqy2y/8QAGREAAwADAAAAAAAAAAAAAAAAAAERECEx/9oACAEDAQE/EKnok4TH/8QAFxEBAQEBAAAAAAAAAAAAAAAAEQABEP/aAAgBAgEBPxA2Wef/xAAeEAEAAgMAAwEBAAAAAAAAAAABABEhMUFRkaFhgf/aAAgBAQABPxDCCyH2ZwbWW9M5LLaD2VKkTxwOoVqyAR1LOVbdzLo0uq35uciin9qUPfkorOjUpyuE/ITh9n//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "The over the top shirt and pant",
            "title": "The over the top shirt and pant",
            "src": "/static/cec721bd6a095e790957b33ad9d42461/9aaa0/udr-2023-23.jpg",
            "srcSet": ["/static/cec721bd6a095e790957b33ad9d42461/f93b5/udr-2023-23.jpg 300w", "/static/cec721bd6a095e790957b33ad9d42461/b4294/udr-2023-23.jpg 600w", "/static/cec721bd6a095e790957b33ad9d42461/9aaa0/udr-2023-23.jpg 671w"],
            "sizes": "(max-width: 671px) 100vw, 671px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      